import React, { Component } from 'react';
import muteIcon from '../../media/images/icons/mute-icon.png';
import soundIcon from '../../media/images/icons/sound-icon.png';
import LocalStorage from '../../local-storage/LocalStorage';
import SoundRepository from '../../game/handlers/SoundRepository';

export default class MuteButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isMuted: this.isMuted()
        }

        this.soundRepository = SoundRepository;
    }

    componentDidMount() {
        this.applyMuteStatus(this.state.isMuted);
        // this.soundRepository.getMoveCardSounds();
    }

    isMuted = () => {
        let isMuted = localStorage.getItem("isMuted");

        // if isMuted doesn't exist
        if (isMuted === undefined || isMuted === null) {
            LocalStorage.setItem('isMuted', false);
            return false;
        }

        return JSON.parse(isMuted);
    }

    applyMuteStatus = (toMute) => {
        if (toMute) {
            this.soundRepository.muteAllSounds();
        }
        else {
            this.soundRepository.unMuteAllSounds();
        }
    }

    onChangeMuteBtn = () => {
        this.applyMuteStatus(!this.state.isMuted);
        this.setState({ isMuted: !this.state.isMuted });
        LocalStorage.setItem('isMuted', !this.state.isMuted);
    }

    render() {
        return (
            <img
                alt="mute_btn"
                className="mute-btn"
                onClick={this.onChangeMuteBtn}
                src={this.state.isMuted ? muteIcon : soundIcon}
                draggable="false" />
        );
    }
}

